/**
 * Email/password users must verify email (Firebase link). Google and other OAuth providers skip this.
 */
export function userNeedsEmailPasswordVerification(user) {
  if (!user || user.isAnonymous) return false
  if (!user.email || user.emailVerified) return false
  const ids = (user.providerData || []).map((p) => p.providerId)
  if (ids.includes('google.com')) return false
  // Only enforce for password provider (email/password sign-up)
  return ids.includes('password')
}

export function getEmailVerificationContinueUrl() {
  if (typeof window === 'undefined') return 'https://primedocumentsign.web.app/'
  const { origin, pathname } = window.location
  return `${origin}${pathname || '/'}`
}
